import React, { useCallback } from 'react';
import { FormControl, Select } from '@material-ui/core';
import useStyles from './styles';
import { Filter, Option } from '../../../../../types/main';
import { addOrRemoveFilterValue } from '../../utils';

type Props = {
  label: string;
  name: string;
  filtersState: Filter[];
  updateFiltersState: (filters: Filter[]) => void;
  options: Option[];
};

const FilterSelect = ({
  label,
  name,
  filtersState,
  updateFiltersState,
  options,
}: Props) => {
  const classes = useStyles();
  const filter: Filter | undefined = filtersState.find((f) => f.key === name);

  const onChange = useCallback((fValue) => {
    const newFiltersState = addOrRemoveFilterValue(filtersState, name, fValue);
    updateFiltersState(newFiltersState);
  }, [updateFiltersState, filtersState, name]);

  return (
    <FormControl
      variant="outlined"
      className={classes.selectWrapper}
    >
      <div className={classes.label}>{label}</div>
      <Select
        native
        classes={{
          root: classes.select,
        }}
        value={filter?.value || ''}
        onChange={(e) => onChange(e.target.value)}
        inputProps={{
          name: 'age',
          id: 'outlined-age-native-simple',
        }}
      >
        {options.map((option) => (
          <option key={option.key} value={option.key}>{option.label}</option>
        ))}
      </Select>
    </FormControl>
  );
};

export default FilterSelect;
